/// <amd-module name="Wit/WorkItemForm/History/Diffs/CommentDiff" />
import { translateStorageKeysToDisplayNames } from "Mention/Common/DisplayNameStorageKeyTranslationService";
import { usePageContext } from "VSS/Platform/Layout";
import { CommentFormat } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { CoreFieldRefNames } from "Wit/Common/Generated/Constants";
import { CommentFieldValue } from "Wit/WorkItemForm/Common/Components";
import * as React from "react";
import { PropsWithChildren } from "react";

export interface ICommentDiffProps {
    text: string | undefined;
    previousText: string | undefined;
    format: CommentFormat;
}

export const CommentDiff: React.FC<ICommentDiffProps> = props => {
    if (!props.text) {
        return null;
    }
    const text = useTextTranslatedToDisplayNames(props.text);
    const previousText = useTextTranslatedToDisplayNames(props.previousText);

    return (
        <div className="rhythm-vertical-8">
            {text && (
                <CommentBubble>
                    <ins className="comment">
                        <CommentFieldValue refName={CoreFieldRefNames.History} fieldValue={text} commentFormat={props.format} />
                    </ins>
                </CommentBubble>
            )}
            {previousText && (
                <CommentBubble>
                    <del className="comment">
                        <CommentFieldValue refName={CoreFieldRefNames.History} fieldValue={previousText} commentFormat={props.format} />
                    </del>
                </CommentBubble>
            )}
        </div>
    );
};

const useTextTranslatedToDisplayNames = (textToTranslate: string | undefined): string | undefined => {
    const pageContext = usePageContext();
    const [text, setText] = React.useState<string>();
    React.useEffect(() => {
        const translateDisplayNamesFromIdentities = async () => {
            if (textToTranslate) {
                const translatedText = await translateStorageKeysToDisplayNames(pageContext, textToTranslate);
                setText(translatedText);
            }
        };
        translateDisplayNamesFromIdentities().catch(console.error);
    }, [textToTranslate]);

    return text;
};

function CommentBubble({ children }: PropsWithChildren<{}>) {
    return (
        <div className="comment-bubble flex-row flex-center">
            <div className="comment-bubble-arrow" />
            <div className="comment-bubble-body padding-16">{children}</div>
        </div>
    );
}
